import { Injectable } from '@angular/core';
import { AuthURL } from '@core/config/auth-url.config';
import { HttpService } from '@core/services/http.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(private httpService: HttpService) {
     // This is intentional
  }

  getPermissionRoleById(id: string) {
    return this.httpService.get(AuthURL.EndPoints.auth.permission.permissionRoleById.replace('{id}', id));
  }

  getPagePermission(data: any) {
    return this.httpService.post(AuthURL.EndPoints.auth.permission.pagePermission, data);
  }

  getPageLookupPermission() {
    return this.httpService.get(AuthURL.EndPoints.auth.permission.pageLookupPermission);
  }
}
